import React, { useEffect, useState } from 'react'
import { Provider } from 'react-redux'
import { HelmetProvider } from '@dr.pogodin/react-helmet'
import { BrowserRouter } from 'react-router'
import { store } from 'src/store'
import { getPage, getAuthToken, setIsFirstStart } from 'src/store/app.state.store'
import { APIService } from 'api/APIService'
import { initApp, initPage } from 'utils/initUtils'
import { createObservers } from 'utils/createObservers'
import { Storage } from 'utils/storage'
import { useScroll } from 'src/hooks/useScroll'
import { NavigationContext } from 'components/Utility/NavigationContext/NavigationContext'
import { AppContent } from 'src/AppContent'
import apiConfig from './config.json'

APIService.setHost(apiConfig.frontendApi)
APIService.setTokenProvider(() => getAuthToken(store.getState()))

const VISITED_KEY = 'visited'

/** The first visit shows the city picker, except when landing on a salon page */
const markVisit = () => {
  if (!Storage.isDefined) {
    return
  }
  if (!Storage.getItem(VISITED_KEY)) {
    const page = getPage(store.getState())
    if (page?.template !== 'salon-page') {
      store.dispatch(setIsFirstStart(true))
    }
  } else {
    store.dispatch(setIsFirstStart(false))
  }
  Storage.setItem(VISITED_KEY, (new Date()).toString())
}

const onScroll = ({ y }: { y: number }) => {
  if (y > 5) {
    document.body.classList.add('scrolled')
  } else {
    document.body.classList.remove('scrolled')
  }
}

export const App: React.FC = () => {
  const [initError, setInitError] = useState(false)
  const [initLoading, setInitLoading] = useState(!!IS_DEV_SERVER)

  useEffect(() => {
    initApp(store)
      .catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e)
        setInitError(true)
      })
      .then(() => initPage(store, window.location.pathname, window.location.search))
      .then(markVisit)
      // eslint-disable-next-line no-console
      .catch(console.error)
      .finally(() => {
        setInitLoading(false)
      })

    createObservers()
  }, [])

  useScroll(typeof window !== 'undefined' ? window : null, onScroll)

  return (
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter>
          <NavigationContext.Provider value={{ status: 200 }}>
            <AppContent initError={initError} initLoading={initLoading} />
          </NavigationContext.Provider>
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  )
}
